<template>

    <categorias-clientes-form  :idCategoriaCliente="idCategoriaCliente" :idCompany="idCompany" :pag="pag"></categorias-clientes-form>

</template>

<script>
    import CategoriasClientesForm from "../../../Widgets/CategoriasClientes/CategoriasClientesForm";

    export default {
        name: "CategoriaCliente",
        components: {CategoriasClientesForm},
        data() {
            return {
                idCompany: this.$route.params.idCompany,
                pag: this.$route.params.pag,
                idCategoriaCliente: this.$route.params.idCategoriaCliente,
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/CategoriasClientes/CategoriaCliente.vue